module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Git#4-708d2ce0cec4f0de5ca8c4518a751598bd74cf379c83b52cee394c00bfd83653.svg";